import { Component, Inject } from '@angular/core';

import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { SharedModule } from '../../../_shared/shared.module';

import { Currency } from '../../shared/currency.model';
import { CurrencyDetailComponent } from '../../currency-detail/currency-detail.component';

@Component({
  selector: 'app-currency-modal',
  templateUrl: './currency-modal.component.html',
  standalone: true,
  imports: [SharedModule, CurrencyDetailComponent],
})
export class CurrencyModalComponent {
  constructor(
    private ref: MatDialogRef<CurrencyModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data
  ) {}

  modalTitle = this.data.title;
  currency: Currency = this.data.obj;
  mode = this.data.params.mode;
  defaultLanguage = this.data.params.defaultLanguage;
  additionalLanguages = this.data.params.additionalLanguages;

  // Referenced from app-currency-detail
  onSavedCurrency(currency) {
    this.ref.close(currency); // close the dialog
  }

  // Referenced from app-currency-detail
  onCanceledCurrency() {
    this.close();
  }

  close() {
    this.ref.close();
  }
}
